import { Gender } from "./gender";

interface Address {
  city: string | null;
  zipCode: string | null;
  country: string | null;
  street: string | null;
}

export class Register {
  socialSecurityNumber!: string | null ;

  firstName!: string;
  lastName!: string;
  birthDate: string | null = null;
  address: Address = {
    city: null,
    zipCode: null,
    country: null,
    street: null,
  };
  gender: Gender = Gender.EjValt;

  email!: string;
  password!: string;
  phoneNumber!: string;
  agreeMarketing!: boolean;
  subscribeToEmailNotification!: boolean;
}
